<template>
  <div style="width: 100%;">
    <h1 class="text-primary text-center mb-4">Choisissez votre Booster</h1>

    <div class="d-flex flex-column align-center mb-4">
      <div class="text-body-1 mb-2">Quantité à ouvrir : <strong>{{ quantity }}</strong></div>
      <v-btn-toggle v-model="quantity" color="primary" mandatory rounded="lg" divided>
        <v-btn :value="1">1</v-btn>
        <v-btn :value="3">3</v-btn>
        <v-btn :value="5">5</v-btn>
        <v-btn :value="10">10</v-btn>
      </v-btn-toggle>
    </div>

    <div class="booster-deck d-flex justify-center align-center py-10" :style="{ '--deck-divisor': Math.max(1, boosters.length - 1) }">
      <div v-for="(booster, index) in boosters" :key="index" class="booster-choice cursor-pointer" :style="{ zIndex: index }" @click="$emit('select', booster, quantity)">
        <v-sheet class="bg-transparent overflow-hidden mb-4 transition-swing position-relative" width="360">
          <v-img :src="getBoosterImageUrl(booster.image)" height="100%" cover></v-img>
          <v-chip v-if="booster.count > 1" color="primary" class="position-absolute mt-4 font-weight-bold" style="top: 10px; left: 50%; transform: translateX(-50%);" size="x-large" variant="flat" elevation="10">
            x{{ booster.count }}
          </v-chip>
        </v-sheet>
      </div>
    </div>
  </div>
</template>

<script>
import Booster from '@/classes/Booster.js'

export default {
  name: 'BoosterSelection',
  props: {
    boosters: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  emits: ['select'],
  data() {
    return {
      quantity: parseInt(localStorage.getItem('boosterQuantity') || '1')
    }
  },
  methods: {
    getBoosterImageUrl(name) {
      return Booster.buildImageUrl(name);
    },
  },
  watch: {
    quantity(val) {
      localStorage.setItem('boosterQuantity', val);
    }
  }
}
</script>
